import { render } from "./BirthdayReport.vue?vue&type=template&id=4a9e1e30&scoped=true"
import script from "./BirthdayReport.vue?vue&type=script&lang=js"
export * from "./BirthdayReport.vue?vue&type=script&lang=js"

import "./BirthdayReport.vue?vue&type=style&index=0&id=4a9e1e30&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9e1e30"]])

export default __exports__